var map = {
	"./Profile-C4.svg": [
		23890,
		3890
	],
	"./Profile-C4CT.svg": [
		69979,
		9979
	],
	"./Profile-CG.svg": [
		21681,
		1681
	],
	"./Profile-J1.svg": [
		74784,
		4784
	],
	"./Profile-Q5.svg": [
		37997,
		7997
	],
	"./Profile-XC.svg": [
		55304,
		5304
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 34814;
module.exports = webpackAsyncContext;